<nav>
  <a href="/">
    <img src="../../assets/logo.svg" />
  </a>
  <div class="nav-group">
    <app-language-selector class="language-selector-container"></app-language-selector>
    <rm-buttonlink
      *ngFor="let button of navbarButtons"
      class="nav-link"
      [rounded]="true"
      [id]="button.id + '-btn'"
      [design]="button.id === 'view-map' ? 'primary' : 'normal'"
      [href]="button.href"
      [openNewTab]="button.openNewTab"
      >{{ button.labelKey | translate }}</rm-buttonlink
    >
    <button
      class="mobile-menu-toggle"
      [class.active]="isMobileMenuOpen"
      (click)="toggleMobileMenu()"
      aria-label="Toggle mobile menu"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</nav>

<!-- Mobile Menu Drawer -->
<div class="mobile-menu-drawer" [class.open]="isMobileMenuOpen">
  <div class="drawer-content">
    <!-- Close button at the top right -->
    <button class="menu-close-button" (click)="closeMobileMenu()" aria-label="Close menu">
      <span></span>
      <span></span>
    </button>

    <!-- Logo at the top -->
    <div class="menu-header">
      <img src="../../assets/logo.svg" alt="ResistMap Logo" />
      <div class="mobile-language-selector">
        <app-language-selector></app-language-selector>
      </div>
    </div>

    <div class="top-links">
      <a
        *ngFor="let button of navbarButtons"
        [href]="button.href"
        [target]="button.openNewTab ? '_blank' : '_self'"
        class="menu-button"
        [ngClass]="{
          'primary-button': button.id === 'view-map',
          'alert-button': button.id === 'submit-report',
          'yellow-button': button.id === 'donate'
        }"
        (click)="closeMobileMenu()"
      >
        {{ button.labelKey | translate }}
      </a>
    </div>

    <div class="bottom-links">
      <!-- Mobile-specific top section links -->
      <ng-container *ngFor="let link of mobileTopLinks">
        <a
          *ngIf="isInternalLink(link)"
          [routerLink]="getLinkPath(link.href)"
          [fragment]="getLinkFragment(link.href)"
          class="menu-link"
          (click)="closeMobileMenu()"
        >
          {{ link.labelKey | translate }}
        </a>
        <a
          *ngIf="!isInternalLink(link)"
          [href]="link.href"
          [target]="link.openNewTab ? '_blank' : '_self'"
          class="menu-link"
          (click)="closeMobileMenu()"
        >
          {{ link.labelKey | translate }}
        </a>
      </ng-container>

      <!-- Mobile-specific bottom section links -->
      <div class="bottom-section" *ngIf="mobileBottomLinks.length > 0">
        <ng-container *ngFor="let link of mobileBottomLinks">
          <a
            *ngIf="isInternalLink(link)"
            [routerLink]="getLinkPath(link.href)"
            [fragment]="getLinkFragment(link.href)"
            class="menu-link"
            (click)="closeMobileMenu()"
          >
            {{ link.labelKey | translate }}
          </a>
          <a
            *ngIf="!isInternalLink(link)"
            [href]="link.href"
            [target]="link.openNewTab ? '_blank' : '_self'"
            class="menu-link"
            (click)="closeMobileMenu()"
          >
            {{ link.labelKey | translate }}
          </a>
        </ng-container>
      </div>

      <!-- Arsenal logo at the bottom -->
      <div class="arsenal-logo">
        <a href="https://arsenaldemocracy.org" target="_blank">
          <img src="../../assets/project-of-arsenal.svg" alt="A project of Arsenal PAC" />
        </a>
      </div>
    </div>
  </div>
</div>
